import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import '../components/fontawesome/fontawesome';

import PortalAdminInvitesComponent from '../components/invites/invites';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';

//import './css/index.css';
//import './css/header.css';

class PortalAdminInvites extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
				description: '',
				cover: '',
				avatar: '',
			},
			//overview: {},
			//invites: [],
			show: false,
			invite: [],

			//isOpen: false,
			//admins: [0, 0],
			//members: [0, 0],

		};
		this.getInvites = this.getInvites.bind(this);
		this.openInvites = this.openInvites.bind(this);
		this.inviteStatus = this.inviteStatus.bind(this);
		this.invite = this.invite.bind(this);
		this.close = this.close.bind(this);
		this.search = this.search.bind(this);
    this.sendRequest = this.sendRequest.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/admin/admin`, params);
		//consoleLog(x.data);
		let service = this.state.service;
		service.status = true;
		service.name = x.data.servicename;
		this.setState({status: true, service});
		setTitle('Invites', x.data.servicename);
		

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

		//this.getInvites();
	}

	componentWillUnmount() {
	}

	async getInvites() {
		/*
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/admin/admin`, params);
		consoleLog(x.data);

		let service = this.state.service;
		service.status = true;
		service.name = x.data.servicename;
		x.data.overview.shorttitle = x.data.description.title;
		this.setState({isOpen: x.data.isOpen, admins: x.data.admins, members: x.data.members});
		
		*/
	}


	async openInvites() {

	}


	async inviteStatus(id, status) {
		/*let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', id);
		params.append('status', status);
		const x = await putApi('/v3/portal/invites', params);
		
		if( x.status === 200 ) {
			this.getInvites();
		}*/
	}


	async invite() {
		this.setState({show: 'invite'});
	}

	
	async close() {
		this.setState({show: false});
	}
	

	async search(event) {
		if( event?.preventDefault() ) event.preventDefault();
		let search = document.getElementById("search_invites").value;
		if( search.length === 0 ) return;
		consoleLog(search);

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('search', search);
		const x = await postApi('/v3/portal/invites/search', params);

		consoleLog(x.data);
		if( x.status === 200 ) this.setState({invite: x.data});
	}

  async sendRequest(uid) {
    let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('uid', uid);
		await putApi('/v3/portal/invites/request', params);
    await this.search();
  }

	render() {
		const user = this.context;

		/*const invites = this.state.invites.map((e,i) => {
			return (
				<Col md={6} key={i}>
					<div className="card custom-card custom-frame">
						<div className="card-header justify-content-between">
							<div className="card-title">
								{e.fullname}
							</div>
							<div className="dropdown d-flex">
								{e.status === 0 &&
									<ButtonGroup size="sm">
										<Button variant="success" onClick={()=>this.inviteStatus(e.id, 1)}><FontAwesomeIcon icon="check" />&nbsp;Accept</Button>
										<Button variant="danger" onClick={()=>this.inviteStatus(e.id, 2)}><FontAwesomeIcon icon="xmark" />&nbsp;Decline</Button>
									</ButtonGroup>
								}

								{e.status === 1 &&
									<ButtonGroup size="sm">
										<Button variant="success" disabled={true}><FontAwesomeIcon icon="check"/>&nbsp;Accepted</Button>
										
									</ButtonGroup>
								}

								{e.status === 2 &&
									<ButtonGroup size="sm">
										<Button variant="danger" disabled={true}><FontAwesomeIcon icon="xmark"/>&nbsp;Declined</Button>
									</ButtonGroup>
								}
								
							</div>
						</div>
						<div className="card-body">
							<Row>
								<div style={{width: 150}}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} width={140} height={140} />
								</div>
								<Col>

									Fullname: {e.fullname}<br />
									Username: {e.title?e.title:e.username}<br />
									{e.facebook &&
										<>Facebook: <a href={e.facebook} target='_blank' rel="noreferrer">{e.facebook}</a><br /></>
									}
									
									DJing Experience: {e.djing}<br />
									Broadcasting Experience: {e.broadcasting}<br />
									{e.previous &&
										<>Mixes: <a href={e.previous} target='_blank' rel="noreferrer">{e.previous}</a><br /></>
									}
									
									
									
								</Col>
							</Row>
							
						</div>
					</div>
				</Col>
			)
		});*/

		const invite = this.state.invite.map((e,i) => {
			return (
				<Col md={6} key={i}>
					<div className="card custom-card custom-frame">
						<div className="card-header justify-content-between">
							<div className="card-title">
								{e.username}
							</div>
							<div className="dropdown d-flex">
								{e.status === 0 &&
									<ButtonGroup size="sm">
										{/*<Button variant="success" onClick={()=>this.inviteStatus(e.id, 1)}><FontAwesomeIcon icon="check" />&nbsp;Accept</Button>
										<Button variant="danger" onClick={()=>this.inviteStatus(e.id, 2)}><FontAwesomeIcon icon="xmark" />&nbsp;Decline</Button>*/}
									</ButtonGroup>
								}

								{/*e.status === 1 &&
									<ButtonGroup size="sm">
										<Button variant="success" disabled={true}><FontAwesomeIcon icon="check"/>&nbsp;Accepted</Button>
										
									</ButtonGroup>
								*/}

								{/*e.status === 2 &&
									<ButtonGroup size="sm">
										<Button variant="danger" disabled={true}><FontAwesomeIcon icon="xmark"/>&nbsp;Declined</Button>
									</ButtonGroup>
								*/}
								
							</div>
						</div>
						<div className="card-body">
							<Row>
								<div style={{width: 150}}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} width={140} height={140} alt="Avatar" />
								</div>
								<Col>

									Fullname: {e.username}<br />
									Username: {e.title?e.title:e.username}<br />
                  
									{/*e.facebook &&
										<>Facebook: <a href={e.facebook} target='_blank' rel="noreferrer">{e.facebook}</a><br /></>
									*/}
									
									{/*DJing Experience: {e.djing}<br />
									Broadcasting Experience: {e.broadcasting}<br />
									{e.previous &&
										<>Mixes: <a href={e.previous} target='_blank' rel="noreferrer">{e.previous}</a><br /></>
									}*/}

                  {e.invite !== null &&
                    <Button size="sm" disabled={true} variant="success">Invite Sent</Button>
                  }
                  <Button size="sm" onClick={()=>this.sendRequest(e.id)}>Request Invite</Button>
									
									
									
								</Col>
							</Row>
							
						</div>
					</div>
				</Col>
			)
		});

		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
								<Col xs={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Invites</span>
													<p className="fs-13 text-muted mb-0">Requesting DJ's to join your station</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                </Col>
							</Row>
							{/*<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
												{this.state.service.name}
                      </div>
											<div className="dropdown d-flex">
												<ButtonGroup size="sm">
													<Button size="sm" variant="success"><FontAwesomeIcon icon="check" />&nbsp;Invites Open</Button>
													<Button size="sm" variant="success" onClick={()=>this.invite()}><FontAwesomeIcon icon="plus" />&nbsp;Invite DJ</Button>
												</ButtonGroup>
											</div>
                    </div>
                    <div className="card-body">
											<Row>
												<Col>
													Invites: {this.state.overview.invites===true?'Open':'Closed'}<br />
													Admins: {this.state.overview.adminsMax}<br />
													Members: {this.state.overview.membersMax}<br />
													<br />
													Advertise Share Link:<br />
													<a href={`https://ultrastream.io/radio/${this.state.overview.shorttitle.replaceAll(' ','-')}`} target="_blank" rel="noreferrer">https://ultrastream.io/radio/{this.state.overview.shorttitle.replaceAll(' ','-')}</a>
												</Col>
											</Row>
										</div>
									</div>
								</Col>
							</Row>*/}
							<Row>
								<PortalAdminInvitesComponent service={this.state.service.id} mode={'full'} />
							</Row>
						</div>
					</div>
				}

				<Modal
     			show={this.state.show === 'invite'?true:false}
      		size="lg"
      		aria-labelledby="contained-modal-title-vcenter"
					onHide={()=>this.close()}
      		centered
    		>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Invite DJ to {this.state.service.name}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form onSubmit={(e)=>this.search(e)}>
							<Row>
								<Col xs={12} className="mb-3">
									Please enter username or email address of the participant you wish to join:
								</Col>
								<Col xs={12} md={6} className="mb-3">
									<input id="search_invites" type="text" className="form-control" placeholder="Enter username or email address ..." />
								</Col>
								<Col xs={12} className="mb-3">
									<Button size="sm" onClick={(e)=>this.search(e)}>Search</Button>
								</Col>
							</Row>
							<Row>
								{invite}
							</Row>
						</form>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={()=>this.close()}>Close</Button>
					</Modal.Footer>
				</Modal>
			</>
		);
	}
}

const Invites = props => {
  const { service } = useParams();
  return <PortalAdminInvites service={service} {...props} />
}
export default Invites;